import { render, staticRenderFns } from "./online-num.vue?vue&type=template&id=0fa7a890&scoped=true"
import script from "./online-num.vue?vue&type=script&lang=js"
export * from "./online-num.vue?vue&type=script&lang=js"
import style0 from "./online-num.vue?vue&type=style&index=0&id=0fa7a890&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa7a890",
  null
  
)

export default component.exports